import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cart Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cart-outline',
    templateUrl: './icon-cart-outline.component.html',
    styleUrls: ['./icon-cart-outline.component.scss'],
    standalone: false
})
export class IconCartOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
